import { render, staticRenderFns } from "./addactivity.vue?vue&type=template&id=ac187462&scoped=true&"
import script from "./addactivity.vue?vue&type=script&lang=js&"
export * from "./addactivity.vue?vue&type=script&lang=js&"
import style0 from "./addactivity.vue?vue&type=style&index=0&id=ac187462&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac187462",
  null
  
)

export default component.exports